<template>
  <div class="addressContainer" @click="copy">
    <div class="address" :title="address">
      {{ formattedAddress }}
    </div>
    <div class="ml-3 mb-1 copyIconContainer color-tertiary" @click="copy">
      <v-icon
        small
        style="vertical-align: middle"
        title="Click to copy address"
      >
        mdi-content-copy
      </v-icon>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    shorten: { type: Boolean, default: true },
    address: { type: String, default: '0x000' },
  },
  computed: {
    formattedAddress() {
      if (this.shorten && this.address.length > 15) {
        // TODO: Could do address checking here

        var ret =
          this.address.substr(0, 8) +
          '...' +
          this.address.substr(this.address.length - 8, 8)
        return ret
      }

      return this.address
    },
  },
  methods: {
    ...mapActions(['showSnackBar']),
    async copy() {
      try {
        await navigator.clipboard.writeText(this.address)
        this.showSnackBar({ msg: 'Address copied' })
      } catch (err) {
        this.msg = err.message
      }
    },
  },
}
</script>

<style scoped>
.addressContainer {
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  width: 100%;
  align-items: center;
  cursor: pointer;
}

.copyIconContainer {
  opacity: 0.4;
  background-color: var(--paper-background-highlight1);
  border-radius: 2px;
  margin-right: -6px;
  cursor: pointer;
}

.addressContainer:hover .copyIconContainer {
  opacity: 1;
}
</style>
